// Open/close helpers for the mobile navigation drawer (Figma: Menu Click).
// The drawer is the existing `.app-menu` sidebar; the CSS rule
// `html[data-sidenav-size="full"].sidebar-enable .app-menu` slides it in, so we
// toggle the `sidebar-enable` class on <html> and manage a backdrop + scroll lock.
// Shared by the mobile topbar (hamburger) and the sidebar (X / outside-click).

const BACKDROP_ID = "mobile-menu-backdrop";

export function closeMobileMenu(): void {
  document.documentElement.classList.remove("sidebar-enable");
  const backdrop = document.getElementById(BACKDROP_ID);
  if (backdrop) backdrop.remove();
  document.body.style.overflow = "";
}

export function openMobileMenu(): void {
  document.documentElement.classList.add("sidebar-enable");
  if (!document.getElementById(BACKDROP_ID)) {
    const backdrop = document.createElement("div");
    backdrop.id = BACKDROP_ID;
    backdrop.className = "offcanvas-backdrop fade show";
    backdrop.style.zIndex = "1054"; // just under the drawer (1055)
    backdrop.addEventListener("click", closeMobileMenu);
    document.body.appendChild(backdrop);
  }
  document.body.style.overflow = "hidden";
}
